<template>
  <div class="containerBlock">
    <h3 class="fb titleBorder">基础信息</h3>
    <a-row class="rowBox">
      <a-col :span="8">
        版本：{{ details.version }}
      </a-col>
      <a-col :span="8">
        动物类型：{{ details.animalTypeName }}
      </a-col>
      <a-col :span="8">
        配方模型：{{ details.formulaModelName }}
        <a-checkbox default-checked disabled>
          {{ details.isFilledModel == 1 ? '填充配方' : '不填充配方' }}
        </a-checkbox>
      </a-col>
      <a-col :span="8">
        养分选择表：{{ details.animalNutritionName }}
      </a-col>
      <a-col :span="8">
        价格来源：{{ details.priceSourceName }}
      </a-col>
      <a-col :span="8">
        盘重：{{ details.totalWeight }}{{ details.totalWeightUnit || 'kg' }}
      </a-col>
      <a-col :span="8">
        水分挥发：<span v-if="details.moistureVolatilizeStart">{{ details.moistureVolatilizeStart }}%</span>
      </a-col>
      <a-col :span="8">
        分析基础：{{ details.analysisBase }} {{ details.analysisBaseUnit }}
      </a-col>
      <a-col :span="8">
        备注：{{ details.remark }}
      </a-col>
    </a-row>
  </div>
</template>


<script>
export default {
  props: ['details'],
  data() {
    return {

    };
  }
};
</script>
<style lang="scss" scoped>
.fb {
  font-weight: bold;
}

.boxPadding {
  padding-left: 40px;
}

.mr40 {
  margin-right: 40px;
}

.mb20 {
  margin-bottom: 20px;
}

.pRelative {
  position: relative;
}

.disInB {
  display: inline-block;
}

.tag {
  position: absolute;
  right: -90px;
  top: 0;
  font-weight: normal;
  background: #1990ff;
  color: #fff;
  padding: 3px 15px;
  border-radius: 15px;
  font-size: 12px;
}

// .bdb1{
//   border-bottom: 1px solid #ddd;
// }</style>